import { apiClient } from './client';

export async function getFeatureModules(params = {}) {
  const { data } = await apiClient.get('/api/system/feature-modules', { params });
  return data;
}

export async function createFeatureModule(payload) {
  const { data } = await apiClient.post('/api/system/feature-modules', payload);
  return data.data;
}

export async function updateFeatureModule(id, payload) {
  const { data } = await apiClient.put(`/api/system/feature-modules/${id}`, payload);
  return data.data;
}

export async function activateFeatureModule(id) {
  const { data } = await apiClient.patch(`/api/system/feature-modules/${id}/activate`);
  return data.data;
}

export async function deactivateFeatureModule(id) {
  const { data } = await apiClient.patch(`/api/system/feature-modules/${id}/deactivate`);
  return data.data;
}

export async function getFeatures(params = {}) {
  const { data } = await apiClient.get('/api/system/features', { params });
  return data;
}

export async function createFeature(payload) {
  const { data } = await apiClient.post('/api/system/features', payload);
  return data.data;
}

export async function updateFeature(id, payload) {
  const { data } = await apiClient.put(`/api/system/features/${id}`, payload);
  return data.data;
}

export async function activateFeature(id) {
  const { data } = await apiClient.patch(`/api/system/features/${id}/activate`);
  return data.data;
}

export async function deactivateFeature(id) {
  const { data } = await apiClient.patch(`/api/system/features/${id}/deactivate`);
  return data.data;
}

export async function getPlanFeatures(planId) {
  const { data } = await apiClient.get(`/api/system/plans/${planId}/features`);
  return data;
}

export async function updatePlanFeatures(planId, payload) {
  const { data } = await apiClient.put(`/api/system/plans/${planId}/features`, payload);
  return data;
}

export async function getCustomerEntitlements(customerId) {
  const { data } = await apiClient.get(`/api/system/customers/${customerId}/entitlements`);
  return data;
}

export async function getCustomerFeatureOverrides(customerId) {
  const { data } = await apiClient.get(`/api/system/customers/${customerId}/feature-overrides`);
  return data;
}

export async function updateCustomerFeatureOverrides(customerId, payload) {
  const { data } = await apiClient.put(`/api/system/customers/${customerId}/feature-overrides`, payload);
  return data;
}

export async function getTenantEntitlements(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/entitlements`);
  return data;
}

export async function getTenantFeatureOverrides(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/feature-overrides`);
  return data;
}

export async function updateTenantFeatureOverrides(tenantId, payload) {
  const { data } = await apiClient.put(`/api/system/tenants/${tenantId}/feature-overrides`, payload);
  return data;
}

export async function getEntitlementEvaluations(params = {}) {
  const { data } = await apiClient.get('/api/system/entitlement-evaluations', { params });
  return data;
}

export async function getCustomerPortalEntitlements(customerId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/entitlements`);
  return data;
}

export async function getCustomerPortalTenantEntitlements(customerId, tenantId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/tenants/${tenantId}/entitlements`);
  return data;
}
